<template>
    <div class="vehicle-mobile-footer">
        <RenterAccessSignupForm v-if="!featureEnabled('renterAccess')" />
        <VehicleCheckAvailability
            v-else
            class="vehicle-mobile-footer__availability"
            :vehicle="vehicle"
            :not-allowed-to-rent-error="notAllowedToRentError"
            :renter-can-not-book-baloise-vehicle="renterCanNotBookBaloiseVehicle"
            mode="slim"
            @click="$emit('click')"
        />
    </div>
</template>

<script>
import RenterAccessSignupForm from '~/components/onboarding/RenterAccessSignupForm.vue';
import VehicleCheckAvailability from '~/components/vehicle/VehicleCheckAvailability.vue';

export default {
    components: { RenterAccessSignupForm, VehicleCheckAvailability },
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        notAllowedToRentError: {
            type: String,
            default: null,
        },
        renterCanNotBookBaloiseVehicle: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle-mobile-footer {
    z-index: $z-vehicle-mobile-footer;
    background: $white;
    padding: 16px 20px;
    border-top: 1px solid $border-color;
    position: fixed;
    left: 0;
    right: 0;
    bottom: -220px; // Must be low enough to hide the footer even in it's max height state

    &.is-visible {
        transition: bottom 0.5s ease-in-out;
        bottom: 0;
    }

    @include lg {
        display: none;
    }

    &__availability {
        max-width: 440px;
        margin: auto;
    }
}
</style>
